/* Every user dropdown in the app draws people the same way: a coloured circle
   carrying the first letter of the name, with the colour derived from the name
   so one person looks the same on every screen and every reload.

   The ten fills below are picked to stay readable under a white letter.
   stringToColor (AvatarLogo.jsx), the hash this replaces, walked the whole
   24-bit space and could land on near-white, which hid the letter; these are
   also spread wide enough that two people in the same list rarely read as the
   same colour. */
const USER_AVATAR_COLORS = [
  "#C9372C", // red
  "#A54800", // orange
  "#7F5F01", // olive
  "#4C6B1F", // lime
  "#216E4E", // green
  "#206A83", // teal
  "#0055CC", // blue
  "#3B4CA8", // indigo
  "#5E4DB2", // purple
  "#943D73", // magenta
];

/* Grey is the no-name case — an unassigned row, not a person. */
const UNKNOWN_AVATAR_COLOR = "#626F86";

export const userAvatarColor = (name = "") => {
  const key = String(name).trim().toLowerCase();
  if (!key) return UNKNOWN_AVATAR_COLOR;
  let hash = 0;
  for (let i = 0; i < key.length; i += 1) hash = (hash * 31 + key.charCodeAt(i)) % 100000;
  return USER_AVATAR_COLORS[hash % USER_AVATAR_COLORS.length];
};

export const firstLetterOf = (name = "") => {
  const first = String(name).trim()[0];
  return first ? first.toUpperCase() : "?";
};

/* MUI `sx` for a dropdown avatar, for the pickers built on <Avatar>. */
export const userAvatarSx = (size = 28, name = "") => ({
  width: size,
  height: size,
  bgcolor: userAvatarColor(name),
  color: "#ffffff",
  fontSize: `${Math.round(size * 0.44)}px`,
  fontWeight: 600,
});
